import React from 'react';

interface AddJobsiteButtonProps {
  onClick: () => void;
  hasAccess: boolean;
}

const AddJobsiteButton: React.FC<AddJobsiteButtonProps> = ({ onClick, hasAccess }) => {
  if (!hasAccess) return null;
  
  return (
    <button
      id="add-jobsite-btn"
      className="btn-primary text-[24px] sm:text-[16px] rounded-full sm:text-body w-fit sm:w-auto sm:rounded-[8px]"
      onClick={onClick}
    >
      <span className=""> + </span>
      <span className="ml-1 hidden sm:inline">
        Add Jobsite
      </span>
    </button>
  );
};

export default AddJobsiteButton; 